import React from "react";
import { control } from "react-validation";

// Define own Input component
const Input = ({ error, isChanged, isUsed, sizeError, ...props }) => {
  return (
    <div>
      <input type="file" {...props} />
      {isChanged && isUsed && error}
    </div>
  );
};

export const FileInput = control(Input);



// WEBPACK FOOTER //
// ./src/components/lib/FileInputHOC.js